import React from "react";

export default function WpmControl({ value, onChange, className = "", style }) {
  const min = 100;
  const max = 300;
  const pct = Math.max(0, Math.min(100, ((Number(value) - min) / (max - min)) * 100));
  return (
    <label className={`lrp-inline-label ${className}`.trim()} style={{ gap: 10, ...(style || {}) }}>
      <span style={{ fontSize: 16, opacity: 0.9 }}>Words per minute</span>
      <input
        className="lrp-range"
        type="range"
        min={min}
        max={max}
        step={10}
        value={value}
        style={{ '--lrp-range-pct': `${pct}%` }}
        onChange={(e) => onChange?.(Number(e.target.value))}
        aria-label="Teleprompter speed in words per minute"
      />
      <span style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'right' }}>{value} WPM</span>
    </label>
  );
}
